import { render } from "./LabDisciplinesView.vue?vue&type=template&id=f27ee382"
import script from "./LabDisciplinesView.vue?vue&type=script&lang=js"
export * from "./LabDisciplinesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__